const StatusProjectEnum = {
  RECUSADO: '0',
  EM_CADASTRO: '1',
  AGUARDANDO_APROVACAO: '2',
  REPROVADO_COM_AJUSTES: '3',
  APROVADO: '4',
  ENVIADO_TOTVS: '5',
}

export default StatusProjectEnum
